import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import ProductReview from '../ProductReview';
import styles from './index.sass';

const InitialNumReviewsToShow = 4;

class ProductReviewsList extends React.Component {
  static propTypes = {
    reviews: React.PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      showAllReviews: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.reviews !== this.props.reviews) {
      this.setState({showAllReviews: false});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickShowAllReviewsButton(e) {
    this.setState({showAllReviews: true});
  }

  render() {
    let { showAllReviews } = this.state; // Shows all for all types
    let reviewsElements = this.props.reviews.map((obj, i) => {
      // NOTE: Only 'delectable' type reviews are syupported as of now
      if(obj.type !== 'delectable') {return null;}
      let elems = (showAllReviews ? obj.objects : obj.objects.slice(0, InitialNumReviewsToShow)).map((review, ii) => {
        let props = {
          review: review,
          key: ii
        };
        return <ProductReview {...props} />;
      });
      let header = obj.header ? <h4 className={styles.reviewContainerHeader}>{obj.header}</h4> : null;
      let showAllProps = {
        className: styles.showAllReviewsButton,
        onClick: this.handleOnClickShowAllReviewsButton.bind(this)
      };
      return (
        <div className={styles.reviewContainer} key={i}>
          {header}
          <div className={styles.reviewsList}>{elems}</div>
          {showAllReviews || obj.objects.length < InitialNumReviewsToShow ? null : <button {...showAllProps}>See more</button>}
        </div>
      );
    });
    return (
      <div className={styles.productReviewsList}>
        {reviewsElements}
      </div>
    );
  }
}

export default ProductReviewsList;



// WEBPACK FOOTER //
// banquet/components/ProductReviewsList/index.js